import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Message} from "primeng/primeng";
import {ListaPrecio} from "./listaPrecio";
import {ListaPrecioService} from "../Services/listaPrecio.service";
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {ListaPrecioDetalle} from "./listaPrecioDetalle";
import {Producto} from "../producto/producto";
import {ProductoService} from "../Services/producto.service";

@Component({
  selector: 'app-lista-precio',
  templateUrl: './lista-precio.component.html',
  styleUrls: ['./lista-precio.component.css']
})
export class ListaPrecioComponent implements OnInit {

  msgs: Message[] = [];
  formListaPrecio : FormGroup;
  formListaPrecioDetalle : FormGroup;
  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  btnNuevoDetalle = true;
  btnCancelarDetalle = false;
  btnGuardarDetalle = false;
  btnGuardarEditarDetalle = false;
  panelRequeridos = false;
  loading = false;
  ListaPreciosRegistrados:ListaPrecio[];
  ListaPreciosDetalleRegistrados:ListaPrecioDetalle[];
  ListaPrecioSeleccionado:ListaPrecio;
  tipoGuardado = '';
  TiendasRegistrados:Tienda[];
  ProductosRegistrados:Producto[];
  panelRequeridosDetalle = false;
  ListaPrecioDetalleSeleccionado:ListaPrecioDetalle;
  verDetalleListaPrecio = false;
  role = localStorage.getItem('role');


  constructor(private servicioProducto:ProductoService,private servicioTienda:TiendaService,
              private servicioListaPrecio:ListaPrecioService,private fb: FormBuilder) { }

  ngOnInit() {
    this.crearControlesListaPrecio();
    this.crearControlesListaPrecioDetalle();
    this.Cancelar();
    this.listarListaPrecios();
    this.listarTiendas();
    this.listarProductos();
  }

  crearControlesListaPrecio(){
    this.formListaPrecio = this.fb.group({
      tienda_id:['',Validators.required],
      nombre:['',Validators.required],
      }
    );

  }
  crearControlesListaPrecioDetalle(){
    this.formListaPrecioDetalle = this.fb.group({
      producto_id:['',Validators.required],
      listaPrecio_id:['',Validators.required],
      precio:['',Validators.required],
      }
    );

  }
  nuevoListaPrecio(){
    if(this.role == 'Administrador'|| this.role == 'Propietario'){
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnGuardarEditar = false;
      this.btnCancelar = true;
      this.formListaPrecio.enable();
      this.formListaPrecio.reset();
      this.panelRequeridos = true;
      this.tipoGuardado = 'guardar';
    }else {
      this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
    }


  }
  Cancelar(){
    this.btnGuardar = false;
    this.btnNuevo = true;
    this.btnCancelar = false;
    this.btnGuardarEditar = false;
    this.formListaPrecio.reset();
    this.formListaPrecio.disable();
    this.panelRequeridos = false;
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  guardarNuevoListaPrecio(){
    if(this.tipoGuardado == 'editar'){
      if(this.role == 'Administrador' || this.role == 'Propietario'){
        this.loading = true;
        this.servicioListaPrecio.putListaPrecio(this.formListaPrecio.value,this.ListaPrecioSeleccionado['idLista'])
          .subscribe(
            rt => {
              this.mensajes('success','Actualizacion',rt);
              this.listarListaPrecios();
              this.loading = false;
            },
            er => this.mensajes('error','Error',er),
            () =>  {
              this.Cancelar();
            });
      }else{
        this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
      }
    }
    else if(this.tipoGuardado == 'guardar') {
      if(this.role == 'Administrador' || this.role == 'Propietario'){
        this.loading = true;
        this.servicioListaPrecio.addListaPrecio(this.formListaPrecio.value)
          .subscribe(
            rt => {
              this.mensajes('success','Guardar',rt);
              this.listarListaPrecios();
              this.loading = false;
            },
            er => this.mensajes('error','Error',er),
            () =>  {
              this.Cancelar();
            });
      }else{
        this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
      }
    }
    this.tipoGuardado = '';
  }
  listarListaPrecios(){
    this.loading = true;
    this.servicioListaPrecio.getListaPrecio()
      .subscribe(
        rt => {
          this.ListaPreciosRegistrados = rt;
          console.log(this.ListaPreciosRegistrados);
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  seleccionarListaPrecio(item:ListaPrecio){
      this.btnNuevo = false;
      this.btnGuardar = false;
      this.btnGuardarEditar = true;
      this.btnCancelar = true;
      this.formListaPrecio.enable();
      this.panelRequeridos = true;
      this.ListaPrecioSeleccionado = item;
      this.ListaPrecioDetalle(item);
      this.listarDetalleListaPrecios();
      this.tipoGuardado = 'editar';
      this.verDetalleListaPrecio = true;
  }
  seleccionarListaPrecioDetalle(item:ListaPrecioDetalle){
    if(this.role == 'Administrador'|| this.role == 'Propietario'){
      this.btnNuevoDetalle = false;
      this.btnGuardarDetalle = false;
      this.btnGuardarEditarDetalle = true;
      this.btnCancelarDetalle = true;
      this.formListaPrecioDetalle.enable();
      this.panelRequeridosDetalle = true;
      this.ListaPrecioDetalleSeleccionado = item;
      this.ListaPrecioDetalleDetalle(item);
      this.tipoGuardado = 'editar';
    }else {
      this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
    }
  }
  ListaPrecioDetalleDetalle(item:ListaPrecioDetalle):void {
   this.formListaPrecioDetalle.patchValue({
   id:item.id,
     producto_id:item.producto_id,
     listaPrecio_id:item.listaPrecio_id,
     precio:item.precio
   });
   }
  ListaPrecioDetalle(item:ListaPrecio):void {
    this.formListaPrecio.patchValue({
      id:item.id,
      tienda_id:item.tienda_id,
      nombre:item['nombreTienda'],
    });
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  listarProductos(){
    this.loading = true;
    this.servicioProducto.getProducto()
      .subscribe(
        rt => {
          this.ProductosRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  nuevoListaPrecioDetalle(){
    if(this.role == 'Administrador'|| this.role == 'Propietario'){
      this.btnNuevoDetalle = false;
      this.btnGuardarDetalle = true;
      this.btnGuardarEditarDetalle = false;
      this.btnCancelarDetalle = true;
      this.formListaPrecioDetalle.enable();
      this.formListaPrecioDetalle.reset();
      this.panelRequeridosDetalle = true;
      this.tipoGuardado = 'guardar';
    }else{
      this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
    }
  }
  CancelarDetalle(){
    this.btnGuardarDetalle = false;
    this.btnNuevoDetalle = true;
    this.btnCancelarDetalle = false;
    this.btnGuardarEditarDetalle = false;
    this.formListaPrecioDetalle.reset();
    this.formListaPrecioDetalle.disable();
    this.panelRequeridosDetalle = false;
    this.verDetalleListaPrecio = false;
  }
  guardarNuevoListaPrecioDetalle(){
    if(this.tipoGuardado == 'editar'){
      if(this.role == 'Administrador' || this.role == 'Propietario'){
        this.loading = true;
        let obj = new Object();
        obj['producto_id'] =this.formListaPrecioDetalle.value['producto_id'];
        obj['listaPrecio_id']=this.formListaPrecioDetalle.value['listaPrecio_id'];
        obj['precio']=this.formListaPrecioDetalle.value['precio'];

        this.servicioListaPrecio.putListaPrecioDetalle(obj)
          .subscribe(
            rt => {
              this.mensajes('success','Actualizacion',rt);
              this.listarListaPrecios();
              this.loading = false;
            },
            er => this.mensajes('error','Error',er),
            () =>  {
            });
      }else{
        this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
      }

    }
    else if(this.tipoGuardado == 'guardar') {
      if(this.role == 'Administrador' || this.role == 'Propietario'){
        this.loading = true;
        this.servicioListaPrecio.addListaPrecioDetalle(this.formListaPrecioDetalle.value)
          .subscribe(
            rt => {
              this.mensajes('success','Guardar',rt);
              this.listarListaPrecios();
              this.loading = false;
            },
            er => this.mensajes('error','Error',er),
            () =>  {
              this.CancelarDetalle();
            });
      }else {
        this.mensajes('warn','Atencion','Para la gestion de Tiendas contacte con Administrador.');
      }
    }
    this.tipoGuardado = '';
  }
  listarDetalleListaPrecios(){
    this.loading = true;
    this.servicioListaPrecio.getDetalleListaPrecio(this.ListaPrecioSeleccionado['idLista'])
      .subscribe(
        rt => {
          this.ListaPreciosDetalleRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        });
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/lista-precio/lista-precio.component.ts